import { createSelector } from 'reselect';
import IpcEquipmentPoolsPredesResdesAnalysisIpcBagIsColumns
  from '../../containers/IpcEquipmentPoolsPredesResdesAnalysisIpcBagIsColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.IPC_BAG_IS_PREDES_RESDES_ANALYSIS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.IPC_BAG_IS_PREDES_RESDES_ANALYSIS.isLoading;

export const getData =
  ReportDefinitions.IPC_BAG_IS_PREDES_RESDES_ANALYSIS.getDataFunction();

export const getColumns =
  createSelector(getData, IpcEquipmentPoolsPredesResdesAnalysisIpcBagIsColumns);
